export default __webpack_public_path__ + "static/media/herc.5f18601c.png";